var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLavatrice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.9,1H6.7C4.9,1,3.5,2.3,3.5,4v16c0,1.7,1.4,3,3.2,3h12.2c1.8,0,3.2-1.3,3.2-3V4C22.1,2.3,20.7,1,18.9,1z M6.7,3h12.2 c0.7,0,1.2,0.4,1.2,1v0.5H5.5V4C5.5,3.4,6,3,6.7,3z M18.9,21H6.7c-0.7,0-1.2-0.4-1.2-1V6.5h14.6V20C20.1,20.6,19.6,21,18.9,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,7.9c-3.3,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1s6.1-2.7,6.1-6.1S16.2,7.9,12.8,7.9z M12.8,18.1c-2.2,0-4.1-1.8-4.1-4.1 c0-2.2,1.8-4.1,4.1-4.1c1.9,0,3.5,1.3,3.9,3.1h-2.5c-0.6,0-1,0.4-1,1s0.4,1,1,1h2.5C16.3,16.8,14.7,18.1,12.8,18.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavatrice);
export default __webpack_public_path__ + "static/media/lavatrice.0436f4833943f2bd2c1b749ef23c33ca.svg";
export { ForwardRef as ReactComponent };